import { DetailedHTMLProps, HTMLAttributes } from "react";

import classNames from "classnames/bind";

import styles from "./Wrapper.module.scss";

const cx = classNames.bind(styles);

type WrapperProps = {
    children?: React.ReactNode;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const Wrapper = ({ children, ...props }: WrapperProps) => {
    return (
        <div {...props} className={cx("sidebarContentWrapper", props?.className)}>
            {children}
        </div>
    );
};

export default Wrapper;
